import { ReactNode, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

type SectionCardProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
};

export default function SectionCard({ title, children, defaultOpen = true }: SectionCardProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-white dark:bg-darkbglight rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
      <button
        type="button"
        className="flex w-full items-center justify-between px-6 py-4 text-left border-l-[3px] border-l-entntblue"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
        <ChevronDownIcon
          className={`h-4 w-4 text-gray-400 dark:text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>
      {isOpen && (
        <div className="border-t border-gray-100 dark:border-gray-700 px-6 py-5">
          {children}
        </div>
      )}
    </div>
  );
}
